import type { ImgHTMLAttributes } from "react";
import LogoWithWordmarkSvg from "./logo-with-wordmark.svg";

export function LogoWithWordmark(props: ImgHTMLAttributes<HTMLImageElement>): JSX.Element {
  return <img alt="Double logo with wordmark" src={LogoWithWordmarkSvg} {...props} />;
}
